<template>
    <div class="terminology-container">
        <el-row type="flex"  justify="space-between">
            <el-col :span="14" style="width: 100%;">
                <div class="terminology-content">
                    <div class="header">
                        <span> {{data.label}}</span>
                        <el-tooltip popper-class="unconfirmed-item"
                                    effect="light"
                                    v-if="!data.confirmed"
                                    :content="toolTip"
                                    placement="right">
                            <i class="unconfirmed"></i>
                        </el-tooltip>
                    </div>
                    <el-divider></el-divider>
                    <div class="card">
                        <div class="card-title">
                            <span class="title">英  文  名</span>
                            <b class="line"></b>
                        </div>
                        <div class="card-body">
                            <p>{{data.english}}</p>
                        </div>

                    </div>

                    <div class="card">
                        <div class="card-title">
                            <span class="title">中文又称</span>
                            <b class="line"></b>
                        </div>
                        <div class="card-body">
                            <p>{{data.alias==null?'无':data.alias}}</p>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-title">
                            <span class="title">曾称</span>
                            <b class="line"></b>
                        </div>
                        <div class="card-body">
                            <p>{{data.deprecatedName==null?'无':data.deprecatedName}}</p>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-title">
                            <span class="title">名词来源</span>
                            <b class="line"></b>
                        </div>
                        <div class="card-body">
                            <p>
                                <template v-if="Array.isArray(data.sources)&&data.sources.length>0">
                                    <span v-for="(item,index) in data.sources" :key="index + item.label ">
                                        {{item.label}} <span v-if="data.sources.length-1!=index">，</span>
                                    </span>
                                </template>
                                <template v-else>
                                    <span>无</span>
                                </template>
                            </p>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-title">
                            <span class="title">ICD编码（艾登编码团队提供）</span>
                            <el-tooltip class="unconfirmed-item"
                                        effect="light"
                                        :content="toolTip"
                                        placement="right">
                                <i class="unconfirmed"></i>
                            </el-tooltip>
                            <b class="line"></b>
                        </div>
                        <div class="card-body">

                            <template v-if="data.icdCodes && data.icdCodes.length != 0 ">
                                <p v-for="(item, index) in data.icdCodes" :key="index + item.icdType + item.icdCode">
                                    <span>{{ ictTypeToName(item.icdType) }}</span>
                                    <span>：</span>
                                    <span>{{ item.icdCode ? item.icdCode : '暂无编码' }}</span>
                                    <span style="margin-left:5px;">{{ item.icdName }}</span>
                                </p>
                            </template>
                            <template v-else-if="data.icdCodes && data.icdCodes.length ==0 && data.hasIcd===true">
                                <p> 疑难疾病分类，审核中 </p>
                            </template>
                            <template v-else-if="data.icdCodes && data.icdCodes.length ==0 && data.hasIcd===false">
                                <p> 经核实，无需编码</p>
                            </template>
                            <template v-else>
                                <p v-if="data.categoryName=='疾病诊断名词'||data.categoryName=='症状体征名词'">
                                    <span>ICD10国家临床版V2.0</span>
                                    <span>：</span>
                                    <span>暂无编码</span>
                                </p>
                                <p v-if="data.categoryName=='手术操作名词'||data.categoryName=='临床检查名词'">
                                    <span>ICD-9-CM-3国家临床版2.0</span>
                                    <span>：</span>
                                    <span>暂无编码</span>
                                </p>

                            </template>

                        </div>
                    </div>

                </div>
            </el-col>
            <el-col :span="10" style="width: 500px;">
                <div class="discuss-content">
                    <div class="comment-body">
                        <div class="header">
                            <span>全部评论</span>
                        </div>
                        <el-divider></el-divider>
                        <div class="comment-list" >
                            <el-scrollbar style="height: 100%;">
                                <p v-if="discussData.length<1" class="discuss-tip">欢迎大家讨论</p>

                                <ul
                                class="list"
                                v-infinite-scroll="load"
                                 >
                                <li v-for="(item,index) in discussData" class="list-item" :key="item.id+ '-' +index" >
                                    <div class="user-avatar">
                                        <img  src="../../assets/img/avatar.png" class='avatar' >
                                    </div>
                                    <div class="user-info">
                                        <div class="name">{{item.username}}</div>
                                        <div class="comments">
                                            <div class="comments-time">
                                                {{ item.createTime | formatDate}}
                                            </div>
                                            <div class="comments-content">
                                                <p><span class="tag" v-if="item.tag">#{{item.tag}}#</span><span >{{item.content}}</span></p>
                                            </div>
                                            <div class="comments-reply-action">
                                                <span class="reply-link" @click="handleShowReplyList(index)">回复 <span v-if="item.relayCount!==0">({{ item.relayCount }})</span></span>
                                            </div>
                                        </div>
                                        <transition name="fade">
                                        <div class="reply-section" :class="'reply-section-id-'+item.id" v-show="false">
                                            <div class="reply-content">
                                                <div class="reply-first-line">
                                                    <div class="reply-info" >
                                                        <div tabindex="0" :id="item.id" contenteditable="true" spellcheck="false" :placeholder="'回复@'+item.username+':'"   @input="onDivInput($event,item)"  class="reply-input reply-comment-input"></div>
                                                    </div>
                                                    <div class="reply-btn-box">
                                                        <el-button class="reply-btn" type="primary" @click="sendCommentReply(item,index)" :disabled="item.disabled || btnDisabled">发送</el-button>
                                                    </div>
                                                </div>
                                                <div class="reply-list-box">
                                                    <div class="reply-list" v-for="(subItem,subIndex) in item.comments" :key="subItem.id+ '-' +subIndex">
                                                        <div class="reply-item">
                                                            <div class="item-reply-datetime"> {{ subItem.createTime | formatDate}}</div>
                                                            <div class="reply-item-first">
                                                                <div class="item-right-first-line">
                                                                    <span class="item-replier">{{ subItem.username }}</span>
                                                                    <span class="item-desc">回复</span>
                                                                    <span class="item-observer">{{ subItem.relayToUserName }}：</span>
                                                                    <span class="item-reply-content">
                                                                            {{ subItem.content }}
                                                                        </span>
                                                                </div>
                                                                <div class="item-right-second-line">
                                                                    <span class="item-reply-link" @click="handleShowReply(subItem.id)">回复</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="reply-input-line" :class="'reply-input-id-'+subItem.id" v-show="false">
                                                           <div class="reply-info" >
                                                                <div tabindex="0" :id="subItem.id" contenteditable="true" spellcheck="false" :placeholder="'回复@'+subItem.username+':'"   @input="onDivInput($event,subItem)"  class="reply-input reply-comment-input"></div>
                                                            </div>
                                                            <div class="reply-btn-box">
                                                                <el-button class="reply-btn" type="primary" @click="sendCommentReply(subItem,index)" :disabled="subItem.disabled || btnDisabled">发送</el-button>
                                                            </div>
                                                        </div>
                                                        <div class="reply-item " style="padding-left: 28px" v-for="(threeItem,threeIndex) in subItem.children" :key="threeItem.id+ '-' +threeIndex">
                                                            <div class="item-reply-datetime">{{ threeItem.createTime | formatDate}}</div>
                                                            <div class="reply-item-first">
                                                                <div class="item-right-first-line">
                                                                    <span class="item-replier">{{ threeItem.username }}</span>
                                                                    <span class="item-desc">回复</span>
                                                                    <span class="item-observer">{{ threeItem.relayToUserName }}：</span>
                                                                    <span class="item-reply-content">
                                                                            {{ threeItem.content }}
                                                                        </span>
                                                                </div>
                                                                <div class="item-right-second-line">
                                                                    <span class="item-reply-link" @click="handleShowReply(threeItem.id)">回复</span>
                                                                </div>
                                                            </div>

                                                            <div class="reply-input-line" :class="'reply-input-id-'+threeItem.id" v-show="false">
                                                                <div class="reply-info" >
                                                                    <div tabindex="0" :id="threeItem.id" contenteditable="true" spellcheck="false" :placeholder="'回复@'+threeItem.username+':'"   @input="onDivInput($event,threeItem)"  class="reply-input reply-comment-input"></div>
                                                                </div>
                                                                <div class="reply-btn-box">
                                                                    <el-button class="reply-btn" type="primary" @click="sendCommentReply(threeItem,index)" :disabled="threeItem.disabled || btnDisabled">发送</el-button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
<!--
                                                    <div class="fetch-more-reply" @click="handleFetchMoreReplys(index)" v-if="item.totalPageCount>1"><span>加载更多</span> </div>
-->
                                                </div>
                                            </div>
                                        </div>
                                        </transition>
                                    </div>
                                </li>

                            </ul>

                            </el-scrollbar>
                        </div>
                    </div>
<!--                    <el-divider></el-divider>-->
                    <div class="line"></div>
                     <div class="comment-publish">
                          <div class="tags">
                              <span :class="['tag-item', tagsSelectIndex === index ? 'tag-item-selected' : '']" @click="handleTagSelect(index)" v-for="(item,index) in tagsText" :key="index">{{item}}</span>
                          </div>
                          <div class="comment-box">
                              <el-input
                                      type="textarea"
                                      :autosize="{ minRows: 5, maxRows: 5}"
                                      placeholder="请输入评论内容"
                                      v-model="comments"
                                      maxlength="200"
                                      show-word-limit
                                      style="resize:none"
                              >
                              </el-input>
                              <div class="btn-publish" @click="handlePublish">
                                  <span class="btn-send">发送</span>
                              </div>
                          </div>
<!--
                          <div class="tag-selected" v-show="false">{{tagsSelectText}}</div>
-->
                     </div>
                </div>
            </el-col>
        </el-row>
        <el-dialog
                class="confirm-dialog"
                :visible.sync="dialogVisible"
                width="25%"
                top="35vh"
                >
            <div class="el-dialog__title" slot="title">
                <div class="title-content"><i  class="el-icon-warning-outline title-icon"></i><span class="title-tip">提示</span></div>
            </div>
            <span class="body-content">你的讨论还没发送,跳转后内容不会保存</span>
            <span slot="footer" class="dialog-footer">
            <el-button type="text"  @click="goPublishNext">发送并跳转</el-button>
            <el-button  type="primary" @click="dialogVisible = false" size="small" plain>取消</el-button>
            <el-button type="success" style="margin-left: 0;" size="small" @click="goNext">跳转</el-button>
             </span>
        </el-dialog>
    </div>
</template>

<script>
    String.prototype.trim = function (char, type) {
        if (char) {
            if (type == 'left') {
                return this.replace(new RegExp('^\\'+char+'+', 'g'), '');
            } else if (type == 'right') {
                return this.replace(new RegExp('\\'+char+'+$', 'g'), '');
            }
            return this.replace(new RegExp('^\\'+char+'+|\\'+char+'+$', 'g'), '');
        }
        return this.replace(/^\s+|\s+$/g, '');
    };
    // TODO
    import $ from 'jquery';
    import homeApi from '../../api/home';
    import discussApi from '../../api/discussion';
    import termManageDataApi from '../../api/termManageData';
    import {po_Last_Div} from '@/lib/utils'
    export default {
        name:'terminology',
        data() {
            return {
                id:0,
                data:{},
                count: 3,
                loading: false,
                comments:'',
                discussData:[],
                fromId:'',
                paginations:{
                    pageIndex:1,
                    totalRowCount:0,
                    totalPageCount:1,
                    pageSize:20
                },
                dialogVisible:false,
                // tagsText:['#建议#','#报错#','#其他#'],
                tagsText:['#新增#','#同义词#','#删除#','#其他#'],
                tagsSelectIndex:'',
                tagsSelectText:'',
                replyComment:'',
                replyPageInfo:{
                    pageIndex:1,
                    pageSize:10,
                },
                btnDisabled: false,
                toolTip: '《常用临床医学名词（2019年版）》暂未收录',
                dictOpts: []
            }
        },
        watch: {
            comments(val) {
                if(val.length==200){
                    this.$message.warning('已达到最大评论字数限制')
                }
            }

        },
        filters: {
            formatDate(time) {
                return  time.substring(0,16)
            }
        },
        methods: {
            ictTypeToName(icdType){
              return this.dictOpts.length>0 && this.dictOpts.filter(v => v.id === icdType)[0].dictName
            },
            async getIcdDictsList(){
              let res = await termManageDataApi.getIcdDictsList();
              if (res.success) {
                this.dictOpts = res.data;
              } else {
                this.$message.error(res.message);
              }
            },
            async handleFetchMoreReplys(i){
                //加载更多的时候 pageSize翻倍 ，totalPageCount>1，加载按钮就显示
                let obj = Object.assign({},this.discussData[i]);
                // obj.pageSize*2
                let res = await discussApi.getDiscReplyList (obj.id, this.replyPageInfo.pageIndex, null);
                let data  =  res.data.map(item=>{
                    item.disabled = true;
                    return item;
                })
                let replyList = this.translateDataToTree(data,obj.id)
                obj.disabled = true;
                obj.comments = replyList;
                obj.pageSize = res.pageSize;
                obj.totalPageCount = res.totalPageCount;
                this.discussData.splice(i,1,obj)

            },
            async handleShowReply(id){
                $('.reply-input-id-'+id).toggle(500)
            },
            async sendCommentReply(item,index){
                // let content =  document.getElementById(id).innerText
                // if(content===''){
                //     this.$message.warning('请输入回复内容')
                //     return ;
                // }
                //
                // let res = await discussApi.addDiscReply (id, content);
                // if(res ){
                //     this.$message.success('发送成功')
                //     $('.reply-input-id-'+id).toggle(500)
                //     document.getElementById(id).innerText = "";
                //     this.$set(this.discussData[index],"relayCount", (this.discussData[index].relayCount+1))
                //     //重新拉取评论数据
                //     this.reloadReplyList(index)
                //
                // }
                this.btnDisabled = true;
                let content =  document.getElementById(item.id).innerText.trim().replace(/&nbsp;/g, '');
                if(content===''){
                    this.$message.warning('请输入回复内容')
                    return ;
                }
                if(content.length>200){
                    this.$message.warning('回复内容最多允许输入200个字')
                    return ;
                }
                item.disabled = true;
                let res = await discussApi.addDiscReply (item.id, content);
                item.disabled = false;
                if(res ){
                    this.$message.success('发送成功')
                    $('.reply-input-id-'+item.id).toggle(500)
                    document.getElementById(item.id).innerText = "";
                    this.$set(this.discussData[index],"relayCount", (this.discussData[index].relayCount+1))
                    //重新拉取评论数据
                    this.reloadReplyList(index)

                }
                this.btnDisabled = false;

            },

            /*buildArrToTree(arr, parentId) {
                let dataArr = JSON.parse(JSON.stringify(arr));
                let firstLevelArr = dataArr.filter(item => item.relayTo === parentId);
                let restArr = dataArr.filter(item => item.relayTo !== parentId);

                let pastRecord = {};
                let resultArr = firstLevelArr.map(item => {
                    item.children = [];
                    restArr.forEach(subItem => {
                        if (pastRecord[subItem.id]) {
                            return;
                        }
                        if (subItem.relayTo === item.id) {
                            pastRecord[subItem.id] = true;
                            item.children.push(subItem);
                        }
                    });
                    return item;
                });

                return resultArr;
            },*/

            translateDataToTree(dataArr,discussionId){
                let data = JSON.parse(JSON.stringify(dataArr));
                let iterator = (reverse) => {
                    let i = reverse && (data.length-1) || 0;
                    let hasNext = () => (i >= 0) && (i < data.length);
                    let next = () => data[reverse && (i--) || (i++)];
                    return {
                        hasNext, next
                    }
                };

                let relayMap = {};
                //遍历 找出第一层的relay
                let it = iterator(false);
                while (it.hasNext()) {
                    let v = it.next();
                    if (v.relayTo === discussionId) {
                        relayMap[v.id] = v;
                        v.level = 1;
                        v.children = [];
                    } else {
                        v.level = 2;
                       //  console.log(relayMap)
                         relayMap[v.relayTo].children.push(v);
                        relayMap[v.id] = relayMap[v.relayTo];
                    }
                }
                // return data.filter(v => v.relayTo === discussionId);
                // 评论的回复按照时间倒序
                let resultArr = data.filter(v => v.relayTo === discussionId);
                // let resultArr = this.buildArrToTree(dataArr, discussionId);
                resultArr.sort(function (a, b) {
                    let aDate = +new Date(a.createTime);
                    let bDate = +new Date(b.createTime);
                    return aDate > bDate ? -1 : (aDate === bDate) ? 0 : 1;
                });
                // 回复的回复按照时间正序
                let newResultArr = resultArr.map(item => {
                    if (item && item.children && item.children.length > 0) {
                        item.children.sort(
                            function (a, b) {
                                let aDate = +new Date(a.createTime);
                                let bDate = +new Date(b.createTime);
                                return aDate > bDate ? 1 : (aDate === bDate) ? 0 : -1;
                            }
                        );
                    }
                    return item;
                });
                return newResultArr;

            },
            async reloadReplyList(i){
                let obj = Object.assign({},this.discussData[i]);
                // obj.pageSize
                let res = await discussApi.getDiscReplyList (obj.id, this.replyPageInfo.pageIndex, null);
                let data  =  res.data.map(item=>{
                    item.disabled = true;
                    return item;
                })
                let replyList = this.translateDataToTree(data,obj.id)
                obj.comments = replyList;
                // obj.disabled = true;
                this.updateCommentItemState(obj);
                this.updateListItemState(obj.comments);
                obj.pageSize = res.pageSize;
                obj.totalPageCount = res.totalPageCount;
                this.discussData.splice(i,1,obj)
            },

            updateCommentItemState (commentItem) {
                if (!commentItem) {
                    return;
                }
                let commentInputDom =  document.getElementById(commentItem.id);
                if (commentInputDom) {
                    let content =  commentInputDom.innerText.trim().replace(/&nbsp;/g, '');
                    if (content && content !== '') {
                        commentItem.disabled = false;
                    } else {
                        commentItem.disabled = true;
                    }
                }
            },

            updateListItemState (list) {
                if (!list || list.length === 0) {
                    return;
                }
                list.forEach(item => {
                    if (!document.getElementById(item.id)) {
                        return;
                    }
                    let content =  document.getElementById(item.id).innerText ? document.getElementById(item.id).innerText.trim().replace(/&nbsp;/g, '') : '';
                    if (content !== '') {
                        item.disabled = false;
                    }
                    this.updateListItemState(item.children);
                });
            },

            async handleShowReplyList(i){
                let obj = Object.assign({},this.discussData[i]);
                /*if(this.discussData[i].inputShow){
                    obj.inputShow =false;
                }else {
                    obj.inputShow =true;
                    //获取回复数据 this.replyPageInfo.pageSize
                    let res = await discussApi.getDiscReplyList (obj.id, this.replyPageInfo.pageIndex, null);
                    // console.log(res)
                    let data  =  res.data.map(item=>{
                        item.disabled = true;
                        return item;
                    })
                    let replyList = this.translateDataToTree(data,obj.id)
                    obj.comments = replyList;
                    this.updateListItemState(obj.comments);
                    // obj.disabled = true;//用于控制按钮的启用和禁用
                    this.updateCommentItemState(obj);
                    obj.pageSize = res.pageSize;
                    obj.totalPageCount = res.totalPageCount;

                }
                //这样才能触发视图更新
                this.discussData.splice(i,1,obj)*/
                if(!(obj.comments && obj.comments.length>0 )){
                    //获取回复数据 this.replyPageInfo.pageSize
                    let res = await discussApi.getDiscReplyList (obj.id, this.replyPageInfo.pageIndex, null);
                    // console.log(res)
                    let data  =  res.data.map(item=>{
                        item.disabled = true;
                        return item;
                    })
                    let replyList = this.translateDataToTree(data,obj.id)
                    obj.comments = replyList;
                    this.updateListItemState(obj.comments);
                    // obj.disabled = true;//用于控制按钮的启用和禁用
                    this.updateCommentItemState(obj);
                    obj.pageSize = res.pageSize;
                    obj.totalPageCount = res.totalPageCount;
                    this.discussData.splice(i,1,obj)
                }

                $('.reply-section-id-'+obj.id).toggle(500)
            },
            _replyShow(i){
              return this.discussData[i].inputShow;
            },
            onDivInput(e,item){
                let content = e.target.innerText;
                if(content!=='') {
                    item.disabled = false;
                }else {
                    item.disabled = true;
                }
                if(content.length>200){
                    e.target.innerText = content.substring(0, 200);
                    this.$message.warning('回复内容最多允许输入200个字')
                    let el = document.getElementById(e.target.id);
                    po_Last_Div(el)
                    return false;
                }
            },
            handleTagSelect(index){
                if(this.tagsSelectIndex===index){
                    this.tagsSelectIndex = '';
                    this.tagsSelectText = '';
                }else {
                    this.tagsSelectIndex = index;
                    this.tagsSelectText= this.tagsText[index];
                }
                //tag标签要单独来个div

            },
            async fetchTerminologyInfo(id){
                let data= await homeApi.getTerminologyInfo(id);
                if(data.success){
                    this.data = data.data
                }else {
                    this.$message.error(data.message);
                    return;
                }
            },
            async load () {
                this.loading = true
                if(this.discussData.length<1){
                    let result =  await discussApi.getDiscussionList(this.id,this.fromId)
                    if(result.success){
                        this.discussData = result.data.data
                       // this.paginations.totalRowCount = result.data.totalRowCount
                        this.paginations.totalPageCount = result.data.totalPageCount
                        if( this.discussData.length>1){
                            this.fromId = this.discussData[this.discussData.length-1].id
                        }

                    }else{
                        this.$message.error(result.message)
                    }
                }else {

                    if(this.discussData.length>1&& this.paginations.totalPageCount>1){
                        let result =  await discussApi.getDiscussionList(this.id,this.fromId)
                        if(result.success){
                            this.discussData =[...this.discussData,...result.data.data]
                            this.paginations.totalPageCount = result.data.totalPageCount
                            if( this.discussData.length>1){
                                this.fromId = this.discussData[this.discussData.length-1].id
                            }

                        }else{
                            this.$message.error(result.message)
                        }
                    }

                }
                if(this.discussData.length>0){
                    this.discussData.map(item =>{
                        if(!item.hasOwnProperty('comments')){
                            item.comments = [];
                        }
                        if(!item.hasOwnProperty('inputShow')){
                            item.inputShow = false;
                        }
                        return item;
                    })
                }
                this.loading = false


            },
            async handlePublish(){
                this.comments = this.trimStr(this.comments)
                if(this.tagsSelectIndex===''){
                    this.$message.warning('请选择一个标签')
                    return ;
                }
                if(this.comments===''){
                    this.$message.warning('请输入评论内容')
                    return ;
                }
                // let params ={
                //     tag:this.tagsSelectText,
                //     content:this.comments,
                // }
                // let result= await discussApi.postDiscussion(this.id,this.comments);
                if (this.btnDisabled) {
                    return;
                }
                this.btnDisabled = true;
                let result= await discussApi.addDiscussion(this.id, this.tagsSelectText.trim('#'),this.comments);
                if(result){
                    this.$message.success('发布成功')
                    this.comments = ''
                    this.tagsSelectIndex =''
                    this.tagsSelectText = ''
                    this.discussData = []
                    this.fromId = ''
                    this.load()
                }
                this.btnDisabled = false;

            },
            goNext(){
                this.$emit('canGoNext', 'hi')

            },
            goPublishNext(){
                this.handlePublish()
                this.$emit('canGoNext', 'hi')
            },
            trimStr(str){return str.replace(/(^\s*)|(\s*$)/g,"");}

        },

       async created() {
            let id = this.$route.params.id;

            this.id = id;
            if (id && id != "0") {
                this.fetchTerminologyInfo(id)
            }
            // 拉取字典列表
           await this.getIcdDictsList()
        },

        mounted() {

        },
        beforeRouteUpdate (to, from, next) {
            // 在当前路由改变，但是该组件被复用时调用
            // 举例来说，对于一个带有动态参数的路径 /foo/:id，在 /foo/1 和 /foo/2 之间跳转的时候，
            // 由于会渲染同样的 Foo 组件，因此组件实例会被复用。而这个钩子就会在这个情况下被调用。
            // 可以访问组件实例 `this`
            this.comments = this.trimStr(this.comments)
            if(this.comments!=''){
                this.dialogVisible=true
                this.$on('canGoNext', function (type) {
                    if(type=='hi'){
                        next()
                        this.dialogVisible=false
                    }

                })
            }else {
                next()
            }



        },
        beforeRouteLeave (to, from, next) {
            // 导航离开该组件的对应路由时调用
            // 可以访问组件实例 `this`
            this.comments = this.trimStr(this.comments)
            if(this.comments!=''){
                this.dialogVisible=true
                this.$on('canGoNext', function (type) {
                    if(type=='hi'){
                        next()
                        this.dialogVisible=false
                    }
                })
            }else {
                next()
            }

        }
    }
</script>
<style lang="less">
    .terminology-container{
        .el-textarea__inner{
            resize: none;
        }

        .el-textarea .el-input__count {
            bottom: -20px !important;
        }

            .el-textarea__inner{
            background-color: rgba(246,246,246,1);
            border: none;
            //text-indent: 3em;
        }
        .confirm-dialog{
            font-size: 14px;

            .el-dialog__header {
                /*border-bottom: 1px solid #dcdfe6 ;*/
            }
            .el-dialog__footer{
                /*border-top: 1px solid #dcdfe6 ;*/
            }
            .el-dialog__body{
                text-align: left;
                padding: 0 0 30px 0;
            }
            .title-icon{
                color: #ec5b50;
                font-size:40px;
                vertical-align: middle;
            }
            .title-tip{
                font-size: 16px;
                font-weight: 500;
                margin-left: 20px;
            }
            .body-content{
                display: inline-block;
                font-size:14px;
                font-weight:400;
                color: #969696;
                margin-left: 80px;
            }
            .el-button--text{
                color: #969696;
                font-size:12px;
            }
            .el-button--primary.is-plain {
                margin-left: 24px;
                margin-right: 24px;
                padding: 9px 26px;
                color: #1DAABA;
                background: #FFF;
                border-color: #1DAABA;
                font-size: 14px;
                font-weight:400;
            }
            .el-button--success {
                padding: 9px 26px;
                color: #FFF;
                background-color: #1DAABA;
                border-color: #1DAABA;
                font-size: 14px;
                font-weight:400;
            }
            .el-button--success:focus, .el-button--success:hover {
                background: #1DAABA;
                border-color: #1DAABA;

                color: #FFF;
            }
        }
        .discuss-content{
            .el-textarea .el-input__count{
                bottom: 12px;
            }
        }
        .el-scrollbar__wrap{
            overflow-y: scroll;
            overflow-x: hidden;
        }
        .reply-section {

            input::placeholder {
                color: #AEACAC;
            }

            .el-input__inner {
                height: 32px;
                border-left: none;
                padding: 0;
            }

            .el-input__inner:focus,
            .el-input__inner:hover {
                border-color: #DCDFE6;
            }

            .el-input-group__prepend {
                padding: 0 10px;
                background-color: #FFF;
                border-right: none;
            }
		}
	}

    .el-tooltip__popper.is-light {
        color: #333;
        background: #F2F3F7;
        border-radius: 3px;
        border: 1px solid #DCDEE3;
    }

    .el-tooltip__popper.is-light[x-placement^=right] .popper__arrow {
        border-right-color: #DCDEE3;
    }

    .el-tooltip__popper.is-light[x-placement^=right] .popper__arrow::after {
        border-right-color: #F2F3F7;
    }

</style>
<style lang="less" scoped>
    .terminology-container{
        background-color: #f5f5f5;
        font-family: 'PingFangSC-Regular', 'PingFang SC';
        width: 100%;
        height: 100%;

        i.unconfirmed {
            display: inline-block;
            position: absolute;
            width: 15px;
            height: 15px;
            background-image: url('../../assets/img/unconfirm.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            margin-left: 8px;
        }

        .terminology-content{
            background-color: #fff;
            padding: 24px 32px 54px;
            height: calc(100% - 80px);
            .header{
                span{
                    height:18px;
                    line-height:18px;
                    font-size: 18px;
                    color: #333333;
                    font-weight: 600;
                    white-space: pre-wrap;
                }
            }
            .card{
                margin-top: 30px;
                .card-title{
                    border-left: 4px solid #1DAABA;
                    height: 16px;
                    line-height: 16px;
                    .title{
                        margin-left: 10px;
                        font-size: 16px;
                        font-weight: 600;
                        color: #333333;
                    }

                }
                .card-body{
                    margin-top: 20px;
                    font-weight: 400;
                    font-style: normal;
                    color: #333333;
                    font-size: 14px;
                    p{
                        margin-left: 14px;
                        white-space: pre-wrap;
                    }

                }



            }

        }

        .el-row--flex.is-justify-space-between {
            height: 100%;
        }

        .discuss-content{
            background-color: #fff;
            margin-left: 10px;
            height: calc(100%);
            .comment-body{
                padding: 24px 32px 0;
                height: calc(100% - 32px);
                .header{
                    span{
                        height:18px;
                        line-height:18px;
                        font-size: 18px;
                        color: #333333;
                        font-weight: 600;
                        white-space: pre-wrap;
                    }
                }
                .comment-list{
                    /*overflow:auto;*/
                    height: calc(100% - 300px);
                    text-align: left;
                    margin-top: -14px;
                    .list{
                        margin-top: -20px;
                    }
                    ul,li{
                        padding: 0;
                        margin: 0;
                        list-style: none;
                    }

                    .list-item{
                        margin-top: 24px;
                        min-height: 62px;
                        display: flex;
                        justify-content: flex-start;
                        .user-avatar{
                            .avatar {
                                width: 32px;
                                height: 32px;
                                border-radius: 50%;
                            }
                        }

                        .user-info{
                            margin-left: 10px;
                            .name{
                                font-size:12px;
                                font-weight:400;
                                color:#969696;
                            }
                            .comments{
                                padding: 10px 17px;
                                margin-top: 6px;
                                max-width: 80%;
                                font-size: 14px;
                                color:rgba(51,51,51,1);
                                background:rgba(246,246,246,1);
                                border:1px solid rgba(220,223,230,1);
                                border-radius: 3px;
                                width: 286px;
                                position: relative;
                                .comments-time{
                                    color:rgba(150,150,150,1);
                                }
                                .comments-content{
                                    word-break: break-all;
                                    margin-top: 9px;
                                    font-weight:400;
                                    .tag{
                                        color: #2E68BAFF;
                                        margin-right: 1px;
                                        display: inline-block;
                                    }
                                }
                                .comments-reply-action{
                                    text-align: right;
                                    margin-top: 5px;
                                    .reply-link{
                                        color: #1DAABA;
                                        font-weight:400;
                                        cursor: pointer;
                                    }
                                }
                            }
                            .comments::before {
                                content: '';
                                width: 0;
                                height: 0;
                                border: 6px solid;
                                position: absolute;
                                top: 8px;
                                left: -12px;
                                border-color: transparent #dcdfe6 transparent transparent;
                            }
                            .comments::after {
                                content: '';
                                width: 0;
                                height: 0;
                                border: 8px solid;
                                position: absolute;
                                top: 6px;
                                left: -12px;
                                border-color: transparent #f6f6f6  transparent transparent;
                            }

                        }

                    }

                }

            }
            .discuss-tip {
                margin-left: 37%;
                font-size: 16px;
                font-weight: 400;
            }
            .line{
                display: block;
                height: 1px;
                width: 100%;
                background-color: #DCDFE6;
                margin-top: -215px;
            }
            .comment-publish{
                background-color: #fff;
                padding: 10px;
                position: relative;
                width: 428px;
                .tags{
                    height: 40px;
                    border-radius:3px;
                    background-color: #f6f6f6;
                    color: #2B66BAFF;
                    font-size: 14px;
                    font-weight:400;
                    padding-left: 10px;
                    .tag-item{
                        height: 20px;
                        line-height: 40px;
                        margin-right: 8px;
                        cursor: pointer;
                        padding: 5px 8px;
                        user-select: none;
                    }

                    .tag-item-selected {
                        background-color: #1DAABA;
                        border-radius: 4px;
                        color: #FFF;
                    }

                }
                .comment-box{
                    margin-top: 10px;
                    height: 145px;
                    background-color: #F6F6F6;
                    /*background-color:#F6F6F6;*/
                }
                .tag-selected{
                    position: absolute;
                    top:64px;
                    left: 18px;
                    height: 30px;
                    color: #2B66BAFF;
                    font-size: 14px;
                    font-weight:400;
                    user-select: none;
                    background-color: #f6f6f6;
                }
                .btn-publish{
                    width: 100%;
                    display: flex;
                    justify-content: flex-end;
                    span.btn-send {
                        margin-right: 60px;
                        padding: 3px 10px;
                        height: 20px;
                        line-height: 20px;
                        background-color: #1DAABA;
                        border-radius: 4px;
                        text-align: center;
                        cursor: pointer;
                        font-size:14px;
                        font-weight:400;
                        color:rgba(255,255,255,1);
                        user-select: none;
                    }

                    span.btn-send:after {
                        content: ' ';
                        clear: both;
                    }
                }
            }
        }

        .fade-enter-active, .fade-leave-active {
            /*transition: opacity 0.2s;*/
            transition: all .5s ease;
        }
        .fade-enter, .fade-leave-to {
            /*transform: translateY(100px);*/
            transform: translate3d(0, 100px, 100px);
            opacity: 0;
            /*height: 0px;*/
        }

        .reply-section {
            background-color: #F3F4F8;
            padding: 12px;
            width: 270px;
            .reply-content {
                .reply-btn-box {
                    display: flex;
                    justify-content: flex-end;
                    .reply-btn {
                        width: 45px;
                        padding: 3px 10px;
                        margin: 16px 0 10px;
                        font-size: 12px;
                        height: 24px;
                        font-weight: 400;
                        border-radius:1px;
                    }
                }

                .reply-first-line,.reply-input-line {
                    .reply-info{
                        background-color: #fff;
                        border: 1px solid #1DAABA;
                        border-radius: 3px;
                        box-sizing: content-box;
                        .reply-input{
                            line-height: 14px;
                            font-size: 12px;
                            font-weight:400;
                            padding: 8px 8px;
                            color: #333333FF;
                            background-color: #fff;
                            border-radius: 4px;
                            &:empty:before{
                                content:attr(placeholder);
                                opacity: .4;
                                pointer-events: none;
                                user-select: none;
                            }
                            &:focus:before{
                                content:none
                            }
                            &:focus{
                                /*padding: 7px 7px;*/
                                /*border: 1px solid #1DAABA;*/
                                box-shadow:none;
                                outline:none;
                            }
                        }
                    }

                }
                .pl28{
                    padding-left: 28px;
                }
                .reply-list-box {

                    .reply-list {

                        .reply-item {
                            padding: 11px 0;
                            border-top: 1px solid #DCDCDC;
                            /*border-bottom: 1px solid #D6D6D6;*/
                            display: flex;
                            flex-direction: column;

                            .item-reply-datetime{
                                height:14px;
                                font-size:14px;
                                color:#969696 ;
                            }
                            .reply-item-first {
                                margin-top: 11px;
                                font-size: 14px;
                                .item-right-first-line {
                                    word-break: break-all;
                                    span {
                                        line-height: 20px;
                                    }

                                    .item-replier,
                                    .item-observer {
                                        color: #2B66BA;
                                    }

                                    .item-desc {
                                        color: #969696;
                                        padding: 0 5px;
                                    }

                                    .item-reply-content {
                                        white-space: pre-wrap;
                                    }

                                }

                                .item-right-second-line {
                                    text-align: right;
                                    margin-top: 11px;
                                    .item-reply-link{
                                        color: #1DAABA;
                                        font-weight:400;
                                        cursor: pointer;
                                    }

                                }

                            }
                        }

                        .reply-input-line {
                            margin-top: 10px;
                            border-top: 1px solid #DCDCDC;
                            padding-top: 20px;
                        }
                    }
                    .fetch-more-reply{
                        font-size: 14px;
                        text-align: center;
                        color: #1DAABA;
                        border-top: 1px solid #D6D6D6;
                        cursor: pointer;
                        padding-top: 5px;
                        user-select: none;
                    }
                }

            }
        }


    }

</style>
